import { render, staticRenderFns } from "./OtherButtonComponent.vue?vue&type=template&id=1711f204&scoped=true&lang=html&"
import script from "./OtherButtonComponent.vue?vue&type=script&lang=js&"
export * from "./OtherButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./OtherButtonComponent.vue?vue&type=style&index=0&id=1711f204&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1711f204",
  null
  
)

export default component.exports